import React, { PureComponent } from 'react';
import { Player } from 'ThreeTerminal_pc/video';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ellipsis from '../Ellipsis';
import { Event } from '@ifeng-fe/ui_base';
import { handleAd } from '@src/utils/handleAd';

const defaultBgImage = 'https://x0.ifengimg.com/fe/custom/e157f3715438c8c0c9e2c3df27bb000d.png';

// 测试logo
// https://x0.ifengimg.com/fe/custom/6370dc22722c624ef742e8aeba78ab7a.png

class MainBox extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        adContent: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { content } = props;
        let datakeyMap = content.datakeyMap.filter(item => item.data.length).reverse();

        datakeyMap = datakeyMap.map(datakeyMapItem => {
            return {
                ...datakeyMapItem,
                data: datakeyMapItem.data.map((datakeyMapDataItem, datakeyMapDataIndex) => ({
                    ...datakeyMapDataItem,
                    index: datakeyMapDataIndex,
                })),
            };
        });

        this.state = {
            datakeyMap,
            keyAcitve: datakeyMap[0].dataKey,
            dataActive: datakeyMap[0].data,
            keyConfig: datakeyMap[0].dataKey,
            videoConfig: datakeyMap[0].data,
            indexActive: 0,
            contentFold: true,
            leftTabIndex: 0,
        };
    }

    event = new Event();

    async componentDidMount() {
        const { adContent } = this.props;
        const { tabAd1 } = adContent;
        const ad = tabAd1;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }
            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    }

    // 获取广告
    async getAd(ad) {
        const len = this.state.dataActive.length;
        const callback = await handleAd(ad);

        callback(ad.data, this.event, this.insert);

        this.event.trigger('init', { len, index: 0 });
    }
    insert = (insertArr, replaceArr, adFn) => {
        // console.log('Ten Recommend Callback.', insertArr, replaceArr, adFn);

        if (adFn && typeof adFn === 'function') {
            const { dataActive } = this.state;

            const infoData = [...dataActive];
            const refs = [];

            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            this.setState(
                {
                    dataActive: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        if (ref?.ref?.current) {
                            dom[ref.index] = ref.ref.current;
                        }
                    }

                    adFn(dom);
                },
            );
        }
    };

    playermsg = {
        width: 900,
        height: 506,
        isAuth: 'auth',
        autoPlay: true,
        playerHooks: ({ changePlayIndex }) => {
            this.changePlayIndex = changePlayIndex;
        },
        playerEventTrigger: player => {
            player.on('ended', () => {
                const { indexActive, videoConfig } = this.state;

                if (indexActive < videoConfig.length - 1) {
                    this.setState({
                        indexActive: indexActive + 1,
                    });
                    this.changePlayIndex(indexActive + 1);
                }
            });
            player.on('canplay', () => {
                player.play();
            });
        },
    };

    handlevideoBarArrowClick = direction => {
        // 该页面没有使用rem，可以做的简单点

        // 取消上次动画
        window.cancelAnimationFrame(this.raf);

        const { datakeyMap } = this.state;
        // 获取tab的总数量
        const tabLen = datakeyMap.length;
        // 每屏tab的数量
        const numInView = 4;
        // 获取目前最左侧tab的索引值
        const { leftTabIndex } = this.state;
        // 每个tab的宽度
        const tabWidth = 74;
        // 计算移动次数（每秒60次，想要在0.1s内执行完，就需要6次移动到指定位置）
        const times = 60 * 0.1;
        // 计算每次移动的长度
        const step = tabWidth / times;
        // 获取ref
        const { refHeadView } = this;

        if (direction === 'right') {
            const newLeftTabIndex = leftTabIndex + 1;

            if (newLeftTabIndex + numInView <= tabLen) {
                this.setState({ leftTabIndex: newLeftTabIndex });
                // 目标位置
                const target = tabWidth * newLeftTabIndex;
                // requestAnimationFrame的回调函数
                const raf = () => {
                    const widthLeft = refHeadView.scrollLeft;

                    if (widthLeft < target) {
                        const realLeft = Math.abs(widthLeft - target);
                        const realStep = realLeft >= step ? step : realLeft;

                        refHeadView.scrollLeft = widthLeft + realStep;
                        this.raf = window.requestAnimationFrame(raf);
                    }
                };

                this.raf = window.requestAnimationFrame(raf);
            }
        } else if (direction === 'left') {
            const newLeftTabIndex = leftTabIndex - 1;

            if (newLeftTabIndex >= 0) {
                this.setState({ leftTabIndex: newLeftTabIndex });
                // 目标位置
                const target = tabWidth * newLeftTabIndex;
                // requestAnimationFrame的回调函数
                const raf = () => {
                    const widthLeft = refHeadView.scrollLeft;

                    if (widthLeft > target) {
                        const realLeft = Math.abs(widthLeft - target);
                        const realStep = realLeft >= step ? step : realLeft;

                        refHeadView.scrollLeft = widthLeft - realStep;
                        this.raf = window.requestAnimationFrame(raf);
                    }
                };

                this.raf = window.requestAnimationFrame(raf);
            }
        }
    };

    handleSpreadClick = () => {
        this.setState({
            contentFold: false,
        });
    };

    tabChangeHandle = async (dataKey, index) => {
        const { datakeyMap } = this.state;
        const { data } = datakeyMap.find(item => item.dataKey === dataKey);
        const { adContent } = this.props;
        const { tabAd1 } = adContent;
        const ad = tabAd1;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }
            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }

        this.setState({
            keyAcitve: dataKey,
            dataActive: data,
        });
    };

    render() {
        const { playermsg } = this;
        const { datakeyMap, keyAcitve, dataActive, videoConfig, keyConfig, indexActive, contentFold } = this.state;
        const { content } = this.props;
        const { title, desc, phtvBackgroundImage, phtvLogo, phtvDesc } = content;
        const bgImage = phtvBackgroundImage ? phtvBackgroundImage : defaultBgImage;

        return (
            <div className={styles.main}>
                <div className={styles.wrap}>
                    <div className={styles.wrapBg}>
                        <img src={bgImage} alt="" />
                    </div>
                    <div className={styles.wrapLogo}>{phtvLogo ? <img src={phtvLogo} alt="" /> : null}</div>
                    <div className={styles.videoBox}>
                        <div className={styles.video}>
                            <Player videoConfig={videoConfig} playermsg={playermsg} key={keyConfig} />
                        </div>
                        <div className={styles.videoBar}>
                            <div className={styles.videoBarHead}>
                                <div
                                    className={`${styles.videoBarArrow} ${styles.videoBarArrowLeft}`}
                                    onClick={() => this.handlevideoBarArrowClick('left')}
                                />
                                <div
                                    className={`${styles.videoBarArrow} ${styles.videoBarArrowRight}`}
                                    onClick={() => this.handlevideoBarArrowClick('right')}
                                />
                                <div className={styles.videoBarHeadView} ref={ref => (this.refHeadView = ref)}>
                                    <div className={styles.videoBarHeadScroll}>
                                        {datakeyMap.map((item, index) => {
                                            const { dataKey, year } = item;
                                            const ifActive = dataKey === keyAcitve;

                                            return (
                                                <div
                                                    className={`${styles.videoBarHeadItem} ${
                                                        ifActive ? styles.active : ''
                                                    }`}
                                                    key={dataKey}
                                                    onClick={() => {
                                                        this.tabChangeHandle(dataKey, index);
                                                    }}>
                                                    {year}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.videoBarListPadding}>
                                <div className={styles.videoBarList}>
                                    {dataActive.map((item, index) => {
                                        const { guid, title, posterUrl, newsTime } = item;
                                        const ifActive = keyAcitve === keyConfig && item.index === indexActive;

                                        if (item.type === 'ad') {
                                            return (
                                                <div
                                                    key={`ad_${index}`}
                                                    className={styles.videoBarListItem}
                                                    ref={item.ref}
                                                />
                                            );
                                        }

                                        return (
                                            <div
                                                className={`${styles.videoBarListItem} ${
                                                    ifActive ? styles.active : ''
                                                }`}
                                                key={guid}
                                                onClick={() => {
                                                    console.log(
                                                        dataActive[index].videoPlayUrl,
                                                        dataActive[index].title,
                                                        item.index,
                                                    );
                                                    this.setState(
                                                        {
                                                            videoConfig: dataActive.filter(item => item.type !== 'ad'),
                                                            keyConfig: keyAcitve,
                                                            indexActive: item.index,
                                                        },
                                                        () => {
                                                            this.changePlayIndex(item.index);
                                                        },
                                                    );
                                                }}>
                                                <div className={styles.thumbnailWrap}>
                                                    {posterUrl ? (
                                                        <img
                                                            src={formatImage(posterUrl, 112, 63)}
                                                            className={styles.thumbnail}
                                                        />
                                                    ) : (
                                                        <div className={styles.noThumbnail} />
                                                    )}
                                                </div>
                                                <div className={styles.textWrap}>
                                                    <div className={styles.textWrapTitle}>{title}</div>
                                                    <div className={styles.textWrapTime}>{newsTime}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.contentBox}>
                    <div className={styles.contentTitle}>{title}</div>
                    <Ellipsis
                        customClass={styles.contentDesc}
                        fold={contentFold}
                        addOn={
                            <>
                                <div className={styles.spreadThisTop} />
                                <div className={styles.spreadThis} onClick={this.handleSpreadClick}>
                                    <div className={styles.spreadThisFlex}>
                                        <div className={styles.spreadThisText}>详情</div>
                                        <div className={styles.spreadThisArrow} />
                                    </div>
                                </div>
                            </>
                        }>
                        {phtvDesc || desc}
                    </Ellipsis>
                </div>
            </div>
        );
    }
}

export default errorBoundary(MainBox);
